import React from 'react';
import { NakedButton, Text } from '@qga/roo-ui/components';

import ToggleContent from '@shared/v2/components/ToggleContent';

import BookingConditionsModal from '@/components/BookingConditionsModal';

const FlightsTerms = () => (
  <Text fontSize="sm" color="greys.steel">
    We will do our best to get you where you want to be on time, but we don’t
    guarantee flight times or schedules and they aren’t part of our contract
    with you. Cancellation fees may apply (up to 100% of total booking price).
    &nbsp;
    <ToggleContent
      toggle={(open) => (
        <NakedButton textDecoration="underline" onClick={open}>
          View Booking Conditions
        </NakedButton>
      )}
      content={(close) => <BookingConditionsModal close={close} />}
    />
  </Text>
);

export default FlightsTerms;
